import { Knob } from "primereact/knob";
import styled from "styled-components";
import { PercentageProps } from "./content-submission-end.types";

export const RewardsContainer = styled.div`
	max-width: 1024px;
`;

export const StyledKnob = styled(Knob)`
	.p-knob .p-knob-range,
	.p-knob .p-knob-value {
		stroke-linecap: round;
	}
	svg {
		transform-origin: center;
		stroke-linecap: round;
	}
`;

export const MessageContainer = styled.div`
	text-align: center;
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 24px;
	letter-spacing: 1.2px;
	margin-top: 32px;
	margin-bottom: 64px;
`;

export const Percentage = styled.span<PercentageProps>`
	color: ${(props) => props.color};
`;
export const Congratulation = styled.span`
	color: #000;
	text-align: center;
	font-size: 24px;
	font-style: normal;
	font-weight: 600;
	line-height: 24px;
	letter-spacing: 1.44px;
	@media screen and (max-width: 480px) {
		font-size: 20px;
	}
`;
export const ResultStatusText = styled.span`
	color: #000;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px; /* 150% */
	letter-spacing: 0.96px;
`;
export const RewardLabel = styled.span`
	color: #000;
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px; /* 125% */
	letter-spacing: 1.28px;
`;
